/*!
    * @product/scmp-sdk 1.3.0
    * built by undefined
  */
import{j as t}from"./chunk-M34FN6CF.js";var r=()=>{let{acquisition:{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}}=t();return{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}};export{r as a};
//# sourceMappingURL=chunk-AO75GPKQ.js.map
